"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.right = exports.left = exports.Right = exports.Left = void 0;
var Left = (function () {
    function Left(value) {
        this.value = value;
    }
    Left.prototype.map = function (f) {
        return this;
    };
    Left.prototype.bimap = function (g, f) {
        return new Left(f(this.value));
    };
    Left.prototype.fold = function (whenRight, whenLeft) {
        return whenLeft(this.value);
    };
    Left.prototype.bifold = function (whenRight, whenLeft) {
        return whenLeft(this.value);
    };
    Left.prototype.getOrElse = function (a) {
        return a;
    };
    Left.prototype.isLeft = function () {
        return true;
    };
    Left.prototype.isRight = function () {
        return false;
    };
    Left.prototype.swap = function () {
        return new Right(this.value);
    };
    Left.prototype.filterOrElse = function (p, zero) {
        return this;
    };
    Left.prototype.match = function (whenRight, whenLeft) {
        whenLeft(this.value);
    };
    return Left;
}());
exports.Left = Left;
var Right = (function () {
    function Right(value) {
        this.value = value;
    }
    Right.prototype.map = function (f) {
        return new Right(f(this.value));
    };
    Right.prototype.bimap = function (g, f) {
        return new Right(g(this.value));
    };
    Right.prototype.fold = function (whenRight, whenLeft) {
        return whenRight(this.value);
    };
    Right.prototype.bifold = function (whenRight, whenLeft) {
        return whenRight(this.value);
    };
    Right.prototype.getOrElse = function (a) {
        return this.value;
    };
    Right.prototype.isLeft = function () {
        return false;
    };
    Right.prototype.isRight = function () {
        return true;
    };
    Right.prototype.swap = function () {
        return new Left(this.value);
    };
    Right.prototype.filterOrElse = function (p, zero) {
        return p(this.value) ? this : (0, exports.left)(zero);
    };
    Right.prototype.match = function (whenRight, whenLeft) {
        whenRight(this.value);
    };
    return Right;
}());
exports.Right = Right;
var of = function (a) {
    return new Right(a);
};
var left = function (l) {
    return new Left(l);
};
exports.left = left;
exports.right = of;
//# sourceMappingURL=either.js.map